import styled from 'styled-components';
import { whiteTheme } from 'styles/themes/whiteTheme';

export function SampleNextArrow(props: { onClick?: any; className?: string }) {
  const { onClick } = props;
  return <SampleNextArrowUi className="NextArrow" onClick={onClick} />;
}

export function SamplePrevArrow(props: { onClick?: any; className?: string }) {
  const { onClick } = props;
  return <SamplePrevArrowUi className="PrevArrow" onClick={onClick} />;
}
export const SampleNextArrowUi = styled.div`
  transform: rotate(-45deg);
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 22.5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  right: -30px;
  top: 67px;
  @media screen and (max-width: 1300px) {
    right: -30px;
  }
`;
export const SamplePrevArrowUi = styled.div`
  transform: rotate(135deg);
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 22.5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  left: -30px;
  top: 67px;
  @media screen and (max-width: 1300px) {
    left: -30px;
  }
`;
